import {
  getCommissionExposure,
  getFraudSignals,
  getOtpStateLabel,
  getServiceLifecycleStage,
} from "../../utils/serviceLifecycle";

function ConstructionOpsPanel({ recentServiceBookings = [] }) {
  const fraudSignals = getFraudSignals(recentServiceBookings);
  const otpPendingCount = recentServiceBookings.filter((booking) =>
    ["otp_pending_start", "otp_pending_completion"].includes(booking.status)
  ).length;
  const closurePendingCount = recentServiceBookings.filter(
    (booking) =>
      ["completion_requested", "otp_pending_completion"].includes(booking.status) ||
      !booking.final_project_value
  ).length;

  return (
    <div style={card}>
      <h2 style={{ marginTop: 0 }}>Construction Operations Control</h2>
      <p style={muted}>
        OTP lifecycle, closure capture, and fraud-risk visibility for execution-heavy service bookings.
      </p>

      <div style={metricsGrid}>
        <div style={metricCard}>
          <div style={metricLabel}>OTP Pending</div>
          <div style={metricValue}>{otpPendingCount}</div>
        </div>
        <div style={metricCard}>
          <div style={metricLabel}>Closure Review Queue</div>
          <div style={metricValue}>{closurePendingCount}</div>
        </div>
        <div style={metricCard}>
          <div style={metricLabel}>Fraud Signals</div>
          <div style={metricValue}>{fraudSignals.length}</div>
        </div>
      </div>

      <div style={listWrap}>
        {recentServiceBookings.slice(0, 6).map((booking) => {
          const commissionExposure = getCommissionExposure(booking);

          return (
            <div key={booking.id} style={itemCard}>
              <div style={itemHeader}>
                <strong>{booking.service_title}</strong>
                <span style={badge}>{getServiceLifecycleStage(booking.status)}</span>
              </div>
              <p style={rowText}>OTP State: {getOtpStateLabel(booking)}</p>
              <p style={rowText}>
                Closure Value: Rs{" "}
                {Number(booking.final_project_value || 0).toLocaleString("en-IN")}
              </p>
              <p style={rowText}>Commission: {commissionExposure.label}</p>
              <p style={rowText}>
                Fraud Score Placeholder: {Number(booking.fraud_risk_score || 0)}
              </p>
            </div>
          );
        })}
      </div>

      {fraudSignals.length > 0 ? (
        <div style={signalBox}>
          {fraudSignals.slice(0, 6).map((signal) => (
            <div key={`${signal.bookingId}-${signal.label}`} style={signalPill}>
              {signal.label}
            </div>
          ))}
        </div>
      ) : (
        <p style={muted}>No high-signal fraud placeholders triggered in the recent sample.</p>
      )}
    </div>
  );
}

const card = {
  background: "#111",
  border: "1px solid #222",
  borderRadius: "18px",
  padding: "22px",
};

const muted = {
  color: "#c5c5c5",
  lineHeight: "1.7",
};

const metricsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
  gap: "12px",
  marginTop: "18px",
};

const metricCard = {
  background: "#0d0d0d",
  border: "1px solid #232323",
  borderRadius: "14px",
  padding: "16px",
};

const metricLabel = {
  color: "#a7a7a7",
  fontSize: "13px",
};

const metricValue = {
  marginTop: "10px",
  fontSize: "28px",
  fontWeight: "700",
};

const listWrap = {
  display: "grid",
  gap: "12px",
  marginTop: "18px",
};

const itemCard = {
  background: "#0c0c0c",
  border: "1px solid #222",
  borderRadius: "14px",
  padding: "14px",
};

const itemHeader = {
  display: "flex",
  justifyContent: "space-between",
  gap: "12px",
  flexWrap: "wrap",
};

const badge = {
  borderRadius: "999px",
  padding: "6px 10px",
  background: "#1b1609",
  border: "1px solid #4b3d1b",
  color: "#f5d188",
  fontSize: "12px",
};

const rowText = {
  color: "#d1d1d1",
  margin: "8px 0 0 0",
};

const signalBox = {
  display: "flex",
  gap: "10px",
  flexWrap: "wrap",
  marginTop: "16px",
};

const signalPill = {
  borderRadius: "999px",
  padding: "8px 12px",
  background: "#311515",
  border: "1px solid #6d2d2d",
  color: "#ffb5b5",
  fontSize: "12px",
  fontWeight: "700",
};

export default ConstructionOpsPanel;
